import React from "react";
import TopBar from "./TopBar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white has-sticky-cta">
      <TopBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
